var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-amex',
                        view: publicPath + 'sprite.svg#view-icon-amex',
                        viewBox: '0 0 56 18',
                        title: 'Group 8',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };